const swagger = {
    invalid_zod_type: 'Zod type inválido. Verifique a configuração do protetor de rota.',
    not_supported_zod_type_for_params: 'Zod type não suportado para os parâmetros. Verifique a configuração do protetor de rota.',
};
export default Object.freeze(swagger);
